"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Video Provider Configuration Information Service
 * Video provider configuration REST API for Frumos.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportEncodingType = void 0;
/**
 * Transport Encoding of the AV stream.
 * @export
 * @enum {string}
 */
exports.TransportEncodingType = {
    DashFmp4TransportStream: 'dashFmp4TransportStream',
    DashTransportStream: 'dashTransportStream',
    HlsFmp4TransportStream: 'hlsFmp4TransportStream',
    HlsTransportStream: 'hlsTransportStream',
    Mpeg2TransportStream: 'mpeg2TransportStream',
    SmoothTransportStream: 'smoothTransportStream',
    Unknown: 'unknown'
};
